var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoFlutter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26,
    height: 26,
    viewBox: "0 0 256 317",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M157.666.001L.001 157.666l48.8 48.8L255.268.001zM156.567 145.396L72.15 229.812l48.984 49.716 48.71-48.71 85.425-85.422z",
    fill: "#47C5FB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M121.133 279.531l37.082 37.082h101.053l-88.45-88.45z",
    fill: "#00569E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M71.6 230.364l48.801-48.801 49.537 49.538-48.801 48.8z",
    fill: "#00B5F8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoFlutter);
export default __webpack_public_path__ + "static/media/logo-flutter.c509c6f7ca14d1b1e34b2747b8f07109.svg";
export { ForwardRef as ReactComponent };